import { Button, message, Modal, Select, Space, Spin, Table, TableColumnsType, TableProps, Typography } from "antd";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { BsTable } from "react-icons/bs";
import { HiOutlineClipboardDocumentCheck } from "react-icons/hi2";
import { PiChartBarFill } from "react-icons/pi";
import { useSearchParams } from "react-router-dom";
import { CommonError, CommonSuccess } from "src/entity/common/menus-enum.enum";
import { MonthsDisplay, UnitAllEnum } from "src/entity/common/unit.constant";
import {
  FugitiveVocEmission,
  OptionFilter,
  SummaryVocEmission,
  UnitFugitiveVoc,
  Option,
  ResponseAPI,
  Filter,
} from "src/entity/fugitive/fugitive.entity";
import { ApproveBody, DataApprove, OptionApproval } from "src/entity/voc-approve/voc-approve.entity";
import useNavigationMenu from "src/hook/useNavigationMenu";
import { getOptionMonthSubmit, getOptions, getReportVocEmission, submitReportVoc, updateApproveStep } from "src/services/fugitive.service";
import { companyStore } from "src/stores/company-store";
import { excelStore } from "src/stores/excel-store.interface";
import { profileStore } from "src/stores/profile-store";
import { settingStore } from "src/stores/setting-store";
import { componentPalette } from "src/theme/component-palette";
import { useShallow } from "zustand/react/shallow";
import { canApproveAndViewTable, roleCompanyAdmin } from "../../PermissionCheck/PermissionCheck";
import ModalApproveStep from "src/components/ModalApproveStep/ModalApproveStep";
import { TbRefresh } from "react-icons/tb";
import { formatNumber, parseAndFormatScientificNumberWithoutZeroReturn, parseToFixedDecimalWithComma } from "src/utils/process-number";
import { generateYearArray } from "src/utils/array";
import { getInfoStepApproval, getOptionVocApproval } from "src/services/voc-approval";
import { CloseOutlined, InfoCircleOutlined } from "@ant-design/icons";

type OnChange = NonNullable<TableProps<any>["onChange"]>;
type Filters = Parameters<OnChange>[1];
const { Text } = Typography;

const ReportFugitiveVocEmissionTable = () => {
  const menu = "fugitive";
  const { permissions } = useNavigationMenu();
  const profile = profileStore(useShallow((state) => state.profile));
  const loadingProfile = profileStore(useShallow((state) => state.loading));
  const userId = profile?.userId;
  const email = profile?.email;
  const name = profile?.name;
  const [messageApi, contextHolder] = message.useMessage();

  const [searchParams] = useSearchParams();
  const yearParam = searchParams.get("year");
  const approveNoParam = searchParams.get("approveNo");
  const companyParam = searchParams.get("companyId");
  const prevCompanyIdRef = useRef<string | null>(null);

  const currentYear = new Date().getFullYear();
  const [optionYears, setOptionYears] = useState<number[]>([]);
  const [selectedYear, setSelectedYear] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filter, setFilter] = useState<Filters>({});
  const [optionsFilter, setOptionFilter] = useState<OptionFilter[]>([]);
  const [data, setData] = useState<FugitiveVocEmission[]>([]);
  const [selectedUnit, setSelectedUnit] = useState<string>(UnitAllEnum.KG);
  const [dataAllUnit, setDataAllUnit] = useState<UnitFugitiveVoc>();
  const [summary, setSummary] = useState<SummaryVocEmission[]>();
  const [selectedButton, setSelectedButton] = useState<string>("table");
  const [selectedEmission, setSelectedEmission] = useState<string>("tvoc");
  const [optionEmissions, setOptionEmissions] = useState<Option[]>([]);
  const [isFlowActive, setIsFlowActive] = useState<boolean>(false);

  const [openModalApproveStep, setOpenModalApproveStep] = useState<boolean>(false);
  const [approveData, setApproveData] = useState<DataApprove | null>(null);
  // For new ui approval page
  const [optionApproval, setOptionApproval] = useState<OptionApproval | null>();
  const [selectedYearApprove, setSelectedYearApprove] = useState<number | null>();
  const [selectedNoApprove, setSelectedNoApprove] = useState<number | null>();
  const [selectedApprove, setSelectedApprove] = useState<string>();
  const [optionApprove, setOptionApprove] = useState<Option[]>([]);
  const isInitializedRef = useRef(false);

  const months = MonthsDisplay;

  const excelSetSelectedYear = excelStore(useShallow((state) => state.setSelectedYear));
  const excelSetQueryStr = excelStore(useShallow((state) => state.setQueryStr));

  const emissionMaster = settingStore(useShallow((state) => state.emission));
  const getEmission = settingStore(useShallow((state) => state.getEmission));

  const getAreaByCompanyId = companyStore(useShallow((state) => state.getAreaByCompanyId));
  const areaMaster = companyStore(useShallow((state) => state.dataArea));

  const warningAlert = (message: string | string[], action: string) => {
    const warnModal = Modal.confirm({
      title: (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>Can not {action}</span>
          <CloseOutlined onClick={() => warnModal.destroy()} style={{ cursor: "pointer" }} />
        </div>
      ),
      content: message,
      okText: "OK",
      icon: <InfoCircleOutlined style={{ color: componentPalette.redThird }} />,
      okButtonProps: { style: { textAlign: "center", backgroundColor: componentPalette.primary } },
      cancelButtonProps: { style: { display: "none" } },
      onOk: () => {},
      className: "custom-tmp-modal-warning",
    });
  };

  const fetchYear = () => {
    const years = generateYearArray();
    setOptionYears(years as number[]);
    if (!yearParam) {
      setSelectedYear(years?.[0] as number);
    }
  };

  const calPagination = (current?: number) => {
    if (current) {
      return (current - 1) * 10;
    }
  };

  const createParamFilter = () => {
    let queryParam = "";
    let offset = 0;
    let limit = pageSize;
    if (selectedYear) {
      queryParam += `year=${selectedYear}`;
    }
    if (current) {
      let resultCalOffset = calPagination(current);
      if (resultCalOffset) {
        offset = resultCalOffset;
      }
      queryParam += `&offset=${offset}`;
    }
    if (limit) {
      queryParam += `&limit=${limit}`;
    }

    queryParam += `&emission=${selectedEmission}`;
    queryParam += `&unit=${selectedUnit}`;

    if (filter) {
      const str = Object.entries(filter)
        .filter(([, value]) => value)
        .map(([key, value]) => `&${key}=[${value?.join(",")}]`)
        .join("");
      queryParam += str;
    }

    return queryParam;
  };

  const fetchReportVocEmission = async () => {
    try {
      if (selectedYear) {
        setLoadingData(true);
        const filterParams = createParamFilter();
        const queryString = new URLSearchParams(filterParams).toString();
        let response = await getReportVocEmission(queryString);
        if (response.data.code === 200) {
          setDataAllUnit({ ...response.data.data });
        }
      }
    } catch (error: any) {
      console.error(error);
    } finally {
      setLoadingData(false);

      // setLoading(false);
    }
  };

  const fetchMaster = async () => {
    await getEmission({ type: "global", label: "Emission" });
  };

  const resetApprovalState = () => {
    setApproveData(null);
    setSelectedApprove("");
  };

  const fetchInfoStepApprove = async () => {
    try {
      if (selectedYearApprove && selectedNoApprove) {
        setLoading(true);
        const query = new URLSearchParams({
          menu,
          year: selectedYearApprove.toString(),
          approveNo: selectedNoApprove.toString(),
        }).toString();
        const response = await getInfoStepApproval(query);
        if (response.data.code === 200) {
          const approveInfo = response.data.data;
          setApproveData(approveInfo);
          setSelectedApprove(approveInfo._id || "");
        }
      } else {
        setApproveData(null);
        resetApprovalState();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const resetSelections = () => {
    setOptionApproval(null);
    setSelectedYearApprove(null);
    setSelectedNoApprove(null);
  };

  const fetchOptionVocApprove = async () => {
    try {
      if (yearParam && !selectedYearApprove) return;

      const queryParams = new URLSearchParams({ menu });
      if (selectedYearApprove) {
        queryParams.append("year", selectedYearApprove.toString());
      }
      const queryString = queryParams.toString();

      // Fetch data
      const response = await getOptionVocApproval(queryString);

      if (response.data.code === 200) {
        const { approveNo } = response.data.data || {};
        setOptionApproval({ ...response.data.data });

        if (approveNo) {
          if (!selectedNoApprove && selectedYearApprove && approveNo?.length === 1) {
            setSelectedNoApprove(approveNo[0]);
          }
        } else {
          resetSelections();
        }
      } else {
        resetSelections();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchMonthOfSubmit = async () => {
    try {
      if (selectedYear) {
        setFilterLoading(true);
        const response = await getOptionMonthSubmit({ year: selectedYear });
        if (response.data.code === 200) {
          const data = response.data.data;
          const isActive = data.find((item: any) => item.year == selectedYear)?.statusFlowActive || false;
          // const isActive = month[0].statusFlowActive;
          setIsFlowActive(isActive);
        } else {
          setIsFlowActive(false);
        }
      }
    } catch (error) {
      console.error(error);
      setIsFlowActive(false);
    } finally {
      setFilterLoading(false);
    }
  };

  const handleYearChange = (value: number) => {
    setSelectedYear(value);
    excelSetSelectedYear(value);
  };

  const handleButtonMenuClick = (buttonName: string) => {
    setSelectedButton(buttonName);
    if (buttonName === "table") {
      setOpenModalApproveStep(false);
      if (yearParam && approveNoParam) {
        searchParams.delete("yearParam");
        searchParams.delete("approveNoParam");
        searchParams.delete("companyId");
      }
    } else if (buttonName === "approve") {
      fetchOptionVocApprove();
      setOpenModalApproveStep(true);
      if (yearParam) setSelectedYearApprove(Number(yearParam));
    }
  };

  const handleYearApproveChange = (value: number) => {
    setSelectedYearApprove(value);
    setSelectedNoApprove(null);
  };

  const handleMonthApprovalChange = (value: string) => {
    setSelectedNoApprove(null);
  };

  const handleApproveNoChange = (value: number) => {
    setSelectedNoApprove(value);
  };

  const handleApproveReport = async (approveBody: ApproveBody, action: string) => {
    try {
      setLoading(true);
      const response = await updateApproveStep(approveBody);
      setLoading(false);

      if (response.data.code == 200) {
        if (action === "approved") {
          messageApi.open({
            type: "success",
            content: CommonSuccess.APPROVED_SUCCESSFULL,
          });
        } else if (action === "reject") {
          messageApi.open({
            type: "success",
            content: CommonSuccess.REJECT_SUCCESSFULL,
          });
        }
        await fetchInfoStepApprove();
        await fetchMonthOfSubmit();
      } else {
        messageApi.open({
          type: "error",
          content: CommonError.APPROVED_FAIL,
        });
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const responseData = error?.response?.data as ResponseAPI;
        const actionStr = action === "approved" ? "approve" : "reject";
        if (error?.response?.status === 400) {
          warningAlert(String(responseData.message), actionStr);
        } else {
          messageApi.open({
            type: "error",
            content: CommonError.APPROVED_FAIL,
          });
        }
      }
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getTextWidth = (text: string, font: string) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      context.font = font;

      const metrics = context.measureText(text);
      return metrics.width;
    }
    return 0;
  };

  const getWidth = () => {
    // const cell = document.querySelector(".ant-table-cell") as HTMLElement;
    const tempText = document.createElement("span");
    const fontSize = "30px";
    const fontFamily = "Arial";
    // const fontSize = window.getComputedStyle(tempText).fontSize || "16px"; // Default to 14px if not found
    // const fontFamily = window.getComputedStyle(tempText).fontFamily || "Arial"; // Default to Arial if not found
    const font = `${fontSize} ${fontFamily}`;
    const widthMonth: { [key in keyof SummaryVocEmission]: string } = {} as any;
    months.forEach((month) => {
      const keyMonth = month.dataIndex as keyof SummaryVocEmission;

      const widthAb = summary?.[0]?.[keyMonth] || "";
      const widthIn = summary?.[1]?.[keyMonth] || "";

      const textWidthAb = getTextWidth(String(widthAb), font);
      const textWidthIn = getTextWidth(String(widthIn), font);

      let maxWidth = Math.max(textWidthAb, textWidthIn);

      if (maxWidth < 90) {
        maxWidth = 90;
      }

      widthMonth[keyMonth] = `${maxWidth}px`;
    });
    // setWidthCol(widthMonth);
    // const widthTotalAb = summary?.[0]?.total || "";
    // const widthTotalIn = summary?.[1]?.total || "";
    // const textWidthTotalAb = getTextWidth(String(widthTotalAb), font);
    // const textWidthTotalIn = getTextWidth(String(widthTotalIn), font);
    // let maxWidthTotal = Math.max(textWidthTotalAb, textWidthTotalIn);
    // if (maxWidthTotal == 0) {
    //   maxWidthTotal = 100;
    // }
    // setWidthTotal(`${maxWidthTotal}px`);
  };

  const buttonStyle = (buttonName: string) => ({
    backgroundColor: selectedButton === buttonName ? componentPalette.primary : "initial",
    color: selectedButton === buttonName ? "white" : "initial",
  });

  const fetchOption = async () => {
    try {
      if (selectedYear) {
        setLoading(true);
        const response = await getOptions(selectedYear);
        if (response.data.code === 200) {
          const data = response?.data?.data?.filter;
          if (Array.isArray(data) && data.length > 0) {
            setOptionFilter(data);
          } else {
            setOptionFilter([]);
          }
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeUnit = () => {
    if (selectedUnit === UnitAllEnum.KG) {
      setSelectedUnit(UnitAllEnum.TON);
    } else if (selectedUnit === UnitAllEnum.TON) {
      setSelectedUnit(UnitAllEnum.KG);
    }
  };

  const handleSubmitReport = async () => {
    try {
      if (userId) {
        const payload = {
          userId: userId,
          // months: checkMonths,
          year: selectedYear,
        };
        setLoading(true);
        const response = await submitReportVoc(payload);
        if (response.data.code === 200) {
          messageApi.open({
            type: "success",
            content: CommonSuccess.SUBMIT_SUCCESSFULL,
          });
          fetchMonthOfSubmit();
        } else {
          messageApi.open({
            type: "error",
            content: CommonError.SUBMIT_FAIL,
          });
        }
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const responseData = error?.response?.data as ResponseAPI;
        if (error?.response?.status === 400) {
          warningAlert(String(responseData.message), "submit");
        } else {
          messageApi.open({
            type: "error",
            content: CommonError.SUBMIT_FAIL,
          });
        }
      }
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeEmission = (value: string) => {
    setSelectedEmission(value);
  };

  const onTableChange: TableProps["onChange"] = (pagination: any, filters: any) => {
    let current = pagination.current;
    setFilter(filters);
    setCurrent(current);
  };

  const getMasterLabel = (type: string, text: string) => {
    if (!text || typeof text != "string") return text;
    if (type === "area" && areaMaster) {
      const optValue = areaMaster.find((item) => item._id === text);
      return optValue?.areaName;
    } else {
      return text;
    }
  };

  const mapFilter = (key: string): Filter[] | [] => {
    const resultFilter = optionsFilter.find((item) => item.key === key)?.filter;
    if (resultFilter) {
      const filter: Filter[] = resultFilter?.map((value: any) => {
        let text = getMasterLabel(key, value) ?? value;
        return {
          text,
          value: value,
        };
      });
      return filter;
    } else {
      return [];
    }
  };

  const isDisableSubmitButton = () => {
    if (!canApproveAndViewTable(permissions) || isFlowActive || data?.length == 0) {
      return true;
    } else {
      return false;
    }
  };

  const removeSarchParam = () => {
    searchParams.delete("year");
    searchParams.delete("month");
    searchParams.delete("approveNo");
    searchParams.delete("companyId");
  };

  const resetFilter = () => {
    setFilter({});
  };

  useEffect(() => {
    fetchYear();
  }, []);

  useEffect(() => {
    getWidth();
  }, [summary]);

  useEffect(() => {
    if (!profile?.activeCompany) return;

    const companyId = profile.activeCompany._id;
    if (prevCompanyIdRef.current === companyId) return;
    prevCompanyIdRef.current = companyId;

    const fetchData = async () => {
      const companyId = profile.activeCompany._id;
      setSelectedYear(currentYear);

      if (yearParam && approveNoParam) {
        if (companyId === companyParam) {
          handleButtonMenuClick("approve");
          if (yearParam) setSelectedYearApprove(Number(yearParam));
          if (approveNoParam) setSelectedNoApprove(Number(approveNoParam));
          removeSarchParam();
        }
      } else if (yearParam) {
        // Case: Redirected from "My Task" to the VOC Emission report with only the year parameter
        if (yearParam) setSelectedYear(Number(yearParam));
        if (Number(yearParam) === Number(selectedYear)) {
          searchParams.delete("year");
        }
      } else {
        setSelectedYearApprove(null);
        setSelectedNoApprove(null);
      }
      resetFilter();
      await Promise.all([fetchMaster(), getAreaByCompanyId(companyId), fetchOptionVocApprove()]);
      isInitializedRef.current = true;
    };
    fetchData();
  }, [profile?.activeCompany]);

  useEffect(() => {
    if (selectedYear) {
      fetchMonthOfSubmit();
    }

    if (!isInitializedRef.current) return;
    resetFilter();
  }, [selectedYear]);

  useEffect(() => {
    const queryParam = createParamFilter();
    if (queryParam) {
      excelSetQueryStr(queryParam);
    }
    const fetchData = async () => {
      await Promise.all([fetchReportVocEmission(), fetchOption(), fetchInfoStepApprove()]);
    };
    fetchData();
  }, [current, filter, selectedEmission]);

  useEffect(() => {
    if (dataAllUnit && selectedUnit) {
      const queryParam = createParamFilter();
      if (queryParam) {
        excelSetQueryStr(queryParam);
      }
      const dataUnitSelected = dataAllUnit[selectedUnit];
      if (dataUnitSelected) {
        setData(dataUnitSelected.data);
        setSummary(dataUnitSelected.summary);
      }
    }
  }, [dataAllUnit, selectedUnit]);

  useEffect(() => {
    if (emissionMaster[0] && emissionMaster[0].options) {
      const optEmission = [...emissionMaster[0].options];
      setOptionEmissions(optEmission);
    }
  }, [emissionMaster]);

  useEffect(() => {
    if (!isInitializedRef.current) return;
    fetchOptionVocApprove();
    fetchInfoStepApprove();
  }, [selectedYearApprove, selectedNoApprove]);

  const columns: TableColumnsType = [
    {
      title: "Area",
      dataIndex: "area",
      align: "center",
      width: 40,
      filters: mapFilter("area"),
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: "Emission",
      dataIndex: "emission",
      align: "center",
      width: 40,
      render: (text) => <Text>{text === "TVOC" ? "TVOCs" : text}</Text>,
    },
    {
      title: (
        <>
          <Space>
            Unit
            <Button onClick={handleChangeUnit} type="text" icon={<TbRefresh />} />
          </Space>
        </>
      ),
      dataIndex: "unit",
      align: "center",
      width: 40,
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: "Total Emission (Kg/y)",
      dataIndex: "totalEmission",
      align: "center",
      width: 40,
      render: (text) => <Text>{parseAndFormatScientificNumberWithoutZeroReturn(text, 2)}</Text>,
    },
  ];

  return (
    <div>
      {contextHolder}

      <div style={{ display: "flex", paddingBottom: "10px", gap: "20px", position: "relative" }}>
        <div style={{ paddingRight: "0" }}>
          <div style={{ display: "flex", gap: "10px" }}>
            {selectedButton === "table" ? (
              <Select
                value={selectedYear}
                style={{ width: 120 }}
                onChange={handleYearChange}
                options={optionYears.map((year) => ({ label: year, value: year }))}
                loading={loading}
                size="middle"
              />
            ) : (
              <div style={{ display: "flex", gap: "10px" }}>
                <Select
                  value={selectedYearApprove}
                  style={{ width: 120 }}
                  onChange={handleYearApproveChange}
                  options={optionApproval?.year?.map((year) => ({ label: year, value: year }))}
                  loading={loading}
                  size="middle"
                />

                <Select
                  value={selectedNoApprove}
                  style={{ width: 120 }}
                  onChange={handleApproveNoChange}
                  options={optionApproval?.approveNo?.map((approveNo) => ({ label: approveNo, value: approveNo }))}
                  loading={loading}
                  size="middle"
                />
              </div>
            )}

            {/* Emission Select */}
            {selectedButton === "table" && (
              <Select
                value={selectedEmission}
                style={{
                  width: 120,
                  visibility: selectedButton === "table" ? "visible" : "hidden",
                }}
                onChange={handleChangeEmission}
                options={optionEmissions}
                loading={loading}
                size="middle"
              />
            )}
          </div>
        </div>

        <div style={{ display: "flex", gap: "10px", paddingRight: "120px" }}>
          <Button
            size="middle"
            style={buttonStyle("table")}
            icon={<BsTable style={{ fontSize: "18px" }} />}
            onClick={() => handleButtonMenuClick("table")}
          />
          <Button
            size="middle"
            style={buttonStyle("chart")}
            icon={<PiChartBarFill style={{ fontSize: "18px" }} />}
            onClick={() => handleButtonMenuClick("chart")}
          />
          <Button
            size="middle"
            style={buttonStyle("approve")}
            icon={<HiOutlineClipboardDocumentCheck style={{ fontSize: "18px" }} />}
            onClick={() => handleButtonMenuClick("approve")}
          />
        </div>
      </div>

      {selectedButton === "table" && (
        <Table
          className="w-full"
          style={{ whiteSpace: "nowrap" }}
          dataSource={canApproveAndViewTable(permissions) ? data : []}
          columns={columns}
          onChange={onTableChange}
          scroll={{ x: "max-content", y: data ? (data?.length === 0 ? undefined : 500) : undefined }}
          loading={loading || loadingData || filterLoading}
          pagination={false}
          rowKey={(record, index) => `${record._id}-${index}`}
          summary={(pageData) => {
            // console.log("summary", summary);
            if (pageData.length > 0) {
              return (
                <Table.Summary fixed="bottom">
                  {summary?.map((row, index) => (
                    <Table.Summary.Row>
                      <Table.Summary.Cell index={index} colSpan={2}>
                        <div style={{ textAlign: "center" }}>
                          <Text>{row.label}</Text>
                        </div>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={index} colSpan={1}>
                        <div>
                          <Text>{row.unit}</Text>
                        </div>
                      </Table.Summary.Cell>

                      <Table.Summary.Cell index={index} colSpan={1}>
                        <div>
                          <Text>
                            {row.totalEmission
                              ? row.key === "intensity"
                                ? parseToFixedDecimalWithComma(row.totalEmission, 2)
                                : parseToFixedDecimalWithComma(row.totalEmission, 2)
                              : 0}
                          </Text>
                        </div>
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  ))}
                </Table.Summary>
              );
            }
          }}
        />
      )}

      <div style={{ paddingTop: "20px", justifyContent: "flex-end", display: "flex" }}>
        {selectedButton == "table" && profile?.roles.includes(roleCompanyAdmin) && (
          <Button type="primary" style={{}} onClick={handleSubmitReport} disabled={isDisableSubmitButton()}>
            Submit
          </Button>
        )}
      </div>

      {openModalApproveStep && approveData && userId && selectedApprove && email && name && (
        <>
          {loading || loadingProfile || filterLoading ? (
            <Spin style={{ display: "flex", justifyContent: "center", alignItems: "center" }} />
          ) : (
            <ModalApproveStep
              data={approveData}
              userId={userId}
              approveId={selectedApprove}
              email={email}
              name={name}
              onApprove={(approveBody, action) => {
                handleApproveReport(approveBody, action);
              }}
            />
          )}
        </>
      )}
    </div>
  );
};
export default ReportFugitiveVocEmissionTable;
